package com.example.mystybag.appCore.views

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.ui.unit.dp
import androidx.compose.material3.RadioButton
import androidx.compose.material3.RadioButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.appCore.logic.pages.LanguageSelectionBottomSheetViewModel
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p48
import com.example.mystybag.core.views.AppTheme

@Composable
fun LanguageSelectionBottomSheetView(viewModel: LanguageSelectionBottomSheetViewModel) {
    val state = viewModel.uiState.subscribeAsState()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = p16)
    ) {
        Texts.TitleLarge(
            text = sharedString(SR.strings.language),
            textAlign = TextAlign.Start,
            color = AppTheme.current.colors.onSurface,
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = p24)
        )

        listOf(
            "bg" to sharedString(SR.strings.bulgarian),
            "en" to sharedString(SR.strings.english)
        ).forEach { (code, label) ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(p48)
                    .clickable { viewModel.onLanguageSelected(code) }
                    .padding(vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                RadioButton(
                    selected = state.value.currentLanguageCode == code,
                    onClick = { viewModel.onLanguageSelected(code) },
                    colors = RadioButtonDefaults.colors(
                        selectedColor = AppTheme.current.colors.primary,
                        unselectedColor = AppTheme.current.colors.onSurfaceVariant
                    )
                )
                Texts.TitleMedium(
                    text = label,
                    color = AppTheme.current.colors.onSurface,
                    modifier = Modifier.padding(start = 8.dp)
                )
            }
        }
    }
}
